export class ValuesGroup<T> {
  groupName: string;
  values: T[];
  allowDeleteValues: boolean;
  backgroundColor: string;

  constructor(groupName: string, values: T[], allowDeleteValues: boolean, backgroundColor: string) {
    this.groupName = groupName;
    this.values = values;
    this.allowDeleteValues = allowDeleteValues;
    this.backgroundColor = backgroundColor;
  }
}
